import { htmxExcludedWidgets } from '../../Client/utils/htmx.js';
import shopifyGenericDefaults from '../shopify-generic/config.js';

export default {
  ...shopifyGenericDefaults,
  includes: ['shopify-generic'],
  searchPageUrl: '/search',
  isHtmxMode: true,
  fitmentSearch: {
    ...shopifyGenericDefaults.fitmentSearch,
    isExtraFieldsAlwaysVisible: Boolean(window.document.querySelector('[hx-trigger*="cm-htmx-update"]')),
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) => ![...htmxExcludedWidgets, 'HeaderVehicleWidget'].includes(w.name),
    ),
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'HeaderVehicleWidget'),
      template: 'fitmentSearch/htmxCollapsibleVehicleWidget',
    },
    {
      name: 'HeaderVehicleWidget_search',
      type: 'VehicleWidget',
      location: '#cm-ymm-search',
      template: 'fitmentSearch/htmxSearchVehicleWidgetContainer',
      isAlwaysActive: false,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
    },
  ],
};
